/* 布局组件 */ 
import Layout from '@/page/layout'
// import fun
const _import = require('../_import')
// scope dash
const scope = 'dash'

export default {
  path: '/dash',
  name: 'dash',
  component: Layout,
  redirect: '/index',
  meta: {title: '首页', icon: ''},
  children: [{
    path: 'tasks',
    name: 'tasks',
    component: _import(`${scope}/tasks`),
    meta: {title: '任务中心', icon: ''}
  }, 
  {
    path: 'aitest',
    name: 'aitest',
    component: _import(`${scope}/aitest`),
    meta: {title: 'ai测试', icon: ''}
    },
  {
    path: 'tasksSearch',
    name: 'tasksSearch',
    component: _import(`${scope}/tasksSearch`),
    meta: {title: '任务查询', icon: ''}
  },
]

}



// WEBPACK FOOTER //
// ./src/router/modules/dash.js